var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',{attrs:{"role":"main","id":"20220302"}},[_c('div',{staticStyle:{"height":"calc(100vh - 236px)"}},[_c('router-view',{key:202204041504})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }